export default "__VITE_ASSET__4934e7f8__"